module.exports = __webpack_public_path__ + "media/images/abagail-2-0d546befd5c1a69829fb8a4d9253b510.png";